export const getSolutionQuery = (solutionId: string | string[]) => {
    return {
        'fields.solutions.sys.id': solutionId,
    };
};
export const getTechnologyQuery = (technologyId: string | string[]) => {
    return {
        'fields.technologies.sys.id': technologyId,
    };
};
export const getServicesQuery = (servicesId: string | string[]) => {
    return {
        'fields.services.sys.id': servicesId,
    };
};
export const getCompanyTopicQuery = (companyTopicId: string | string[]) => {
    return {
        'fields.companyTopics.sys.id': companyTopicId,
    };
};
export const getIndustryQuery = (industryId: string | string[]) => {
    return {
        'fields.industries.sys.id': industryId,
    };
};
export const getExcludeQuery = (id: string | string[]) => {
    return {
        'sys.id[nin]': id,
    };
};
